module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-379f2d9e.png";